export default "__VITE_ASSET__I95LilK3__"